var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{staticClass:"mt-5",attrs:{"xs12":""}},[_c('canvas',{staticStyle:{"width":"100%"},attrs:{"id":"platform","height":"400"}})])}
var staticRenderFns = []

export { render, staticRenderFns }